module.exports = __webpack_public_path__ + "static/c6-640045197207cb6f4d2e113970750a73.png";